/** Updates wait for every controlled document to close. Never reload a running session. */
export async function registerAppRelease(releaseId: string, serviceWorker: ServiceWorkerContainer): Promise<void> {
  if (!/^[a-f\d]{64}$/.test(releaseId)) throw new Error('Invalid app release ID.');
  const pin = (): void => serviceWorker.controller?.postMessage({ type: 'rl-web:pin-release', releaseId });
  serviceWorker.addEventListener('controllerchange', pin);
  try {
    await serviceWorker.register('/service-worker.js', { scope: '/', updateViaCache: 'none' });
    pin();
  } catch (error) {
    serviceWorker.removeEventListener('controllerchange', pin);
    throw error;
  }
}

if (import.meta.env.PROD && typeof document !== 'undefined' && 'serviceWorker' in navigator) {
  const releaseId = document.querySelector<HTMLMetaElement>('meta[name="app-release"]')?.content;
  if (releaseId) {
    // Registration is optional infrastructure; an unsupported/blocked worker must not block startup.
    void registerAppRelease(releaseId, navigator.serviceWorker).catch((error: unknown) => {
      console.warn('Application release cache unavailable.', error);
    });
  }
}
